import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { cloneDeep } from '@apollo/client/utilities';
import { PathwayGQL } from '@cpd-app/generated';

@Injectable({
  providedIn: 'root'
})
export class PathwayService {
  constructor(private pathwayGQL: PathwayGQL) {}

  public getPathway(pathwayId: any): Observable<any> {
    return this.pathwayGQL
      .fetch(
        { pathwayId },
        {
          fetchPolicy: 'no-cache'
        }
      )
      .pipe(map((data) => cloneDeep(data?.data?.pathway)));
  }
}
